import {
  Autocomplete,
  AutocompleteProps,
  TextField,
  TextFieldProps,
  TooltipProps,
} from '@mui/material';
import TooltipWrapper from './TooltipWrapper';

export type AutocompleteItem = { label: string; value: string };

interface AutocompleteFieldProps
  extends Partial<
    AutocompleteProps<
      AutocompleteItem,
      undefined,
      boolean | undefined,
      undefined
    >
  > {
  label: string;
  isRequired?: boolean;
  error?: boolean;
  showTooltip?: boolean;
  tooltipPlacement?: TooltipProps['placement'];
  textFieldProps?: TextFieldProps;
}

const AutocompleteField = ({
  options,
  label,
  error,
  isRequired,
  value,
  onChange,
  textFieldProps,
  disabled,
  disableClearable,
  showTooltip,
  tooltipPlacement,
}: AutocompleteFieldProps) => {
  return (
    <TooltipWrapper
      showTooltip={showTooltip}
      placement={tooltipPlacement}
      title={typeof value === 'object' ? value?.label : value}
    >
      <Autocomplete
        disablePortal
        disableClearable={disableClearable}
        disabled={disabled}
        options={options || []}
        value={value}
        onChange={onChange}
        renderInput={(params) => (
          <TextField
            {...params}
            label={isRequired ? `${label} *` : label}
            {...textFieldProps}
          />
        )}
        sx={(theme) => ({
          '& .MuiOutlinedInput-notchedOutline': {
            borderColor: error ? theme.palette.error.main : 'inherit',
          },
          '& .MuiInputBase-root.MuiOutlinedInput-root': {
            borderColor: theme.palette.grey[400],
          },
        })}
      />
    </TooltipWrapper>
  );
};

export default AutocompleteField;
